"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var SisDndDirective = /** @class */ (function () {
    function SisDndDirective(el) {
        this.el = el;
    }
    SisDndDirective.prototype.onDragStart = function (event) {
        event.dataTransfer.setData('text/plain', null); // required for firefox
        this.dndManager.dragstart(event, this.dndData);
    };
    SisDndDirective.prototype.onDragEnter = function (event) {
        this.dndManager.dragenter(event, this.dndData);
    };
    SisDndDirective.prototype.onDragOver = function (event) {
        this.dndManager.dragover(event, this.dndData);
    };
    SisDndDirective.prototype.onDrop = function (event) {
        this.dndManager.drop(event, this.dndData);
    };
    SisDndDirective.prototype.onDragEnd = function (event) {
        this.dndManager.dragend(event, this.dndData);
    };
    SisDndDirective.prototype.onDragLeave = function (event) {
        this.dndManager.dragleave(event, this.dndData);
    };
    SisDndDirective.prototype.ngOnChanges = function (changes) {
        if (changes.dndManager && changes.dndManager.currentValue && changes.dndData && changes.dndData.currentValue) {
            this.el.nativeElement.setAttribute('draggable', this.dndManager.draggable(this.dndData));
            this.el.nativeElement.addEventListener('dragstart', this.onDragStart.bind(this), false);
            this.el.nativeElement.addEventListener('dragenter', this.onDragEnter.bind(this), false);
            this.el.nativeElement.addEventListener('dragover', this.onDragOver.bind(this), false);
            this.el.nativeElement.addEventListener('dragleave', this.onDragLeave.bind(this), false);
            this.el.nativeElement.addEventListener('drop', this.onDrop.bind(this), false);
            this.el.nativeElement.addEventListener('dragend', this.onDragEnd.bind(this), false);
        }
    };
    SisDndDirective.prototype.ngOnDestroy = function () {
        this.el.nativeElement.removeEventListener('dragstart', this.onDragStart.bind(this), false);
        this.el.nativeElement.removeEventListener('dragenter', this.onDragEnter.bind(this), false);
        this.el.nativeElement.removeEventListener('dragover', this.onDragOver.bind(this), false);
        this.el.nativeElement.removeEventListener('dragleave', this.onDragLeave.bind(this), false);
        this.el.nativeElement.removeEventListener('drop', this.onDrop.bind(this), false);
        this.el.nativeElement.removeEventListener('dragend', this.onDragEnd.bind(this), false);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisDndDirective.prototype, "dndManager", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisDndDirective.prototype, "dndData", void 0);
    SisDndDirective = __decorate([
        core_1.Directive({
            selector: '[sisDnd]'
        }),
        __metadata("design:paramtypes", [core_1.ElementRef])
    ], SisDndDirective);
    return SisDndDirective;
}());
exports.SisDndDirective = SisDndDirective;
//# sourceMappingURL=sis-dnd.directive.js.map